import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from '@/routes';
import { trackPageView } from '@/lib/gtm';

export const RouterWithGTM = () => {
  useEffect(() => {
    const unsubscribe = router.subscribe((state) => {
      if (typeof window !== 'undefined' && window.dataLayer) {
        const page = state.location.pathname + state.location.search;
        trackPageView(page);
      }
    });

    if (typeof window !== 'undefined' && window.dataLayer) {
      const initialPage = window.location.pathname + window.location.search;
      trackPageView(initialPage);
    }

    return () => {
      unsubscribe();
    };
  }, []);

  return <RouterProvider router={router} />;
};

